import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

// @TODO: add Typescript after configuring it in project https://jira2.wiosna.org.pl/browse/NP-3041
export const useDonorStore = defineStore('DonorStore', () => {
  const donor = ref(null)

  const getDonor = computed(() => donor.value)

  function setDonor(newDonor) {
    donor.value = newDonor
  }

  return { donor, getDonor, setDonor }
})
